import { DotLottieReact, type DotLottie } from '@lottiefiles/dotlottie-react'
import type { CSSProperties } from 'react'
import { useEffect, useState } from 'react'

import gradientLynkLottie from 'src/features/lynk/assets/animated-lynk-gradient.lottie'
import plainLynkLottie from 'src/features/lynk/assets/animated-lynk-plain.lottie'

type AnimatedLynkIconVariant = 'plain' | 'gradient'

interface AnimatedLynkIconProps {
  variant?: AnimatedLynkIconVariant
  autoPlay?: boolean
  loop?: boolean
  width?: number
  height?: number
  style?: CSSProperties
  className?: string
}

const AnimatedLynkIcon = ({
  variant = 'gradient',
  autoPlay = true,
  loop = true,
  width = 120,
  height = 120,
  style,
  className,
}: AnimatedLynkIconProps) => {
  const [dotLottie, setDotLottie] = useState<DotLottie | null>(null)

  useEffect(() => {
    if (!dotLottie) return
    dotLottie.play()
    if (autoPlay) {
      dotLottie.play()
    } else {
      dotLottie.pause()
    }
  }, [autoPlay, dotLottie])

  const src = variant === 'gradient' ? gradientLynkLottie : plainLynkLottie

  const mergedStyle: CSSProperties = {
    width,
    height,
    lineHeight: '145%',
    ...style,
  }

  return (
    <div className="relative" style={{ width, height }}>
      <DotLottieReact
        src={src}
        autoplay={autoPlay}
        loop={loop}
        dotLottieRefCallback={setDotLottie}
        className={className}
        style={mergedStyle}
        speed={0.6}
      />
    </div>
  )
}

export default AnimatedLynkIcon
